module.exports = __webpack_public_path__ + "img/help.f25718b4.svg";